// extracted by mini-css-extract-plugin
export default {"cls1":"SmallAccountMenuButton-cls1_khI","cls2":"SmallAccountMenuButton-cls2__HB SmallAccountMenuButton-cls1_khI"};